<div class="view-container">
  <div class="register-finish">
    <h2 class="ef-headline-2">
      <T
        str="Account created!"
        key="customerPortal.kc.register-finish.title"
        tags="kc-forms, 3.1"
      ></T>
    </h2>
    <mat-card class="mat-elevation-z0 flex flex-row gap-6">
      <mat-icon>done</mat-icon>
      <!-- prettier-ignore -->
      <p
        [innerHTML]="getTranslation()"
      ></p>
    </mat-card>
    <button
      mat-button
      mat-flat-button
      color="primary"
      (click)="submit()"
      [disabled]="submitting"
    >
      <T
        str="Continue to the Emil Frey customer portal"
        key="customerPortal.kc.register-finish.button-kundenportal"
        tags="kc-forms, 3.1"
      ></T>
    </button>
    <form
      #registerBusinessInviteFinishForm
      [action]="viewData.registrationAction"
      method="POST"
    >
      <input type="hidden" name="step" value="finish" />
    </form>
  </div>
</div>
